

export const getGreeting = (t: any) => {
  const now = new Date();
  const hours = now.getHours(); // 0 - 23

  if (hours < 12) {
    return `${t('goodMorning')}`;
  } else if (hours < 18) {
    return `${t('goodAfternoon')}`;
  } else {
    return `${t('goodEvening')}`;
  }
}


